export const ROUTE_LABELS = {
  about: 'About Us',
  philosophy: 'Philosophy',
  team: 'Our Team',
  contact: 'Contact Us',
  services: 'Services',
  careers: 'Careers',
  blogs: 'Blogs',
  'privacy-policy': 'Privacy Policy',
  sitemap: 'Sitemap',

  'first-100-days': 'First 100-180 Days',
  'ipo-leadership': 'IPO Leadership',
  'portfolio-management': 'Portfolio Management',
  'navigating-exits': 'Navigating Exits',
  'mis-fpa': 'MIS & FP&A',
  'valuation-expertise': 'Valuation Expertise',
  'non-pe-engagements': 'Non-PE Engagements',

  'alexandra-reeves': 'Alexandra Reeves',
  'james-whitfield': 'James Whitfield',
  'priya-nair': 'Priya Nair',
  'daniel-osei': 'Daniel Osei',
  'sophia-hartmann': 'Sophia Hartmann',
  'rajan-mehta': 'Rajan Mehta',
};

export const BLOG_TITLES = {
  'future-of-private-equity-trends-shaping-2024':
    'The Future of Private Equity: Trends Shaping 2024',
  'esg-integration-beyond-compliance-to-value-creation':
    'ESG Integration: Beyond Compliance to Value Creation',
  'navigating-exits-in-a-volatile-market':
    'Navigating Exits in a Volatile Market',
};

export const JOB_TITLES = {
  'senior-investment-associate': 'Senior Investment Associate',
  'financial-analyst': 'Financial Analyst',
  'operations-manager': 'Operations Manager',
};